import React, { useContext } from 'react';

import SpinnerContext from '../../contexts/loading';

const Spinner = () => {
  const { isSpinnerShown } = useContext(SpinnerContext);

  return (
    <>
      {isSpinnerShown && (
        <div className="spinner">
          <div className="bounce1" />
          <div className="bounce2" />
          <div className="bounce3" />
        </div>
      )}
    </>
  );
};

export default Spinner;
